module.exports = __webpack_public_path__ + "static/banner.news-51caf7e38222292f0849b12a1010a64b.png";